module.exports = __webpack_public_path__ + "img/crypto-coins.9abe4582.png";